import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { apiClient, formatApiError } from "@/lib/auth";
import { when } from "./kit";

const show = (v) => (v === null || v === undefined || v === "" ? "∅" : typeof v === "object" ? JSON.stringify(v) : String(v));

export const AuditTab = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { apiClient.get("/console/audit?limit=300").then(({ data }) => setRows(data.entries)).catch((e) => toast.error(formatApiError(e))); }, []);
  return (
    <div className="space-y-2" data-testid="console-audit-tab">
      <p className="text-sm text-white/60">Every account and record change made from the System Console (insert-only).</p>
      {rows.map((e) => (
        <div key={e.id} data-testid={`audit-entry-${e.id}`} className="p-3 border border-white/10 rounded-sm">
          <div className="flex flex-wrap gap-x-3 text-[11px] font-mono">
            <span className="text-white/40">{when(e.at)}</span>
            <span className="text-[#d4a017] uppercase">{e.action.replace(/_/g, " ")}</span>
            <span className="text-white/70">{e.target_kind} · {e.target_label}</span>
            <span className="text-white/40">by {e.actor?.name || e.actor?.email}</span>
          </div>
          <div className="mt-1.5 space-y-0.5">
            {Object.entries(e.changes || {}).map(([k, c]) => (
              <div key={k} className="text-xs text-white/70 break-all"><span className="font-mono text-white/50">{k}</span>: {show(c.from)} → <span className="text-white">{show(c.to)}</span>{c.reason && <span className="text-white/40"> ({c.reason})</span>}</div>
            ))}
          </div>
        </div>
      ))}
      {!rows.length && <div className="p-6 text-center text-white/40">No changes logged yet</div>}
    </div>
  );
};
